import { useRouter } from "next/router";
import React, { useEffect, useRef } from "react";

interface BackgroundManagerProps {
  children: React.ReactNode;
}

/**
 * A higher-order component that ensures background processes only run once
 * and aren't affected by re-renders of the main application
 */
const BackgroundManager: React.FC<BackgroundManagerProps> = ({ children }) => {
  const initialized = useRef(false);
  const [shouldRender, setShouldRender] = React.useState(false);
  const router = useRouter();

  // Only initialize background processes once when the router is ready
  useEffect(() => {
    if (router.isReady && !initialized.current) {
      initialized.current = true;
      setShouldRender(true);
    }
  }, [router.isReady]);

  // Only render children when initialized
  if (!shouldRender || !router.isReady) {
    return null;
  }

  return <>{children}</>;
};

export default React.memo(BackgroundManager);
